// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_op-0";
export var animationContainer = "_op-1";
export var itemPrice = "_op-a";
export var itemizedContent = "_op-9";
export var itemizedHeader = "_op-7";
export var itemizedRow = "_op-8";
export var itemizedSection = "_op-6";
export var modalContent = "_op-2";
export var orderName = "_op-3";
export var refundOption = "_op-4";
export var refundOptionsContainer = "_op-5";
export var shippingLabel = "_op-b";
export var totalRow = "_op-c";